import clsx from 'clsx';
import { AnchorHTMLAttributes } from 'react';

import styles from './Link.module.scss';

export const ActionLink = ({
  className,
  ...props
}: AnchorHTMLAttributes<HTMLAnchorElement>) => (
  <a className={clsx(styles.actionLink, className)} {...props} />
);
